import ruRU from 'antd/locale/ru_RU';
import uzUZ from 'antd/locale/uz_UZ';

export const langIds: Record<string, number> = {
  uz: 1,
  ru: 2,
  en: 3
};

export const langs = ['uz', 'ru'];

export const antdLocales = {
  uz: uzUZ,
  ru: ruRU
};

export const dateFormats = {
  DEFAULT: 'DD.MM.YYYY',
  LOCAL_DATE_TIME: 'DD.MM.YYYY HH:mm',
  DATE_TIME: 'DD.MM.YYYY HH:mm:ss'
};

export const colors = {
  black: '#000000',
  white: '#ffffff',
  primary: '#12B76A',
  bgGray: '#F6F7FB',
  green: {
    50: '#ECFDF3',
    100: '#D1FADF',
    200: '#A8F2C6',
    300: '#6FE6A7',
    400: '#36D183',
    500: '#12B76A',
    600: '#079455',
    700: '#057747',
    800: '#075E3A',
    900: '#074D32'
  },
  gray: {
    50: '#F9FAFB',
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
    800: '#1F2A37',
    900: '#111928'
  },
  blue: {
    50: '#EBF5FF',
    100: '#E1EFFE',
    200: '#C3DDFD',
    300: '#A4CAFE',
    400: '#76A9FA',
    500: '#3F83F8',
    600: '#1C64F2',
    700: '#1A56DB',
    800: '#1E429F',
    900: '#233876'
  },
  red: {
    50: '#FDF2F2',
    100: '#FDE8E8',
    200: '#FBD5D5',
    300: '#F8B4B4',
    400: '#F98080',
    500: '#F05252',
    600: '#E02424',
    700: '#C81E1E',
    800: '#9B1C1C',
    900: '#771D1D'
  },
  orange: {
    50: '#FFF8F1',
    100: '#FEECDC',
    200: '#FCD9BD',
    300: '#FDBA8C',
    400: '#FF8A4C',
    500: '#FF5A1F',
    600: '#D03801',
    700: '#B43403',
    800: '#8A2C0D',
    900: '#771D1D'
  },
  yellow: {
    50: '#FDFDEA',
    100: '#FDF6B2',
    200: '#FCE96A',
    300: '#FACA15',
    400: '#E3A008',
    500: '#C27803',
    600: '#9F580A',
    700: '#8E4B10',
    800: '#723B13',
    900: '#633112'
  },
  teal: {
    50: '#EDFAFA',
    100: '#D5F5F6',
    200: '#AFECEF',
    300: '#7EDCE2',
    400: '#16BDCA',
    500: '#0694A2',
    600: '#047481',
    700: '#036672',
    800: '#05505C',
    900: '#014451'
  },
  indigo: {
    50: '#F0F5FF',
    100: '#E5EDFF',
    200: '#CDDBFE',
    300: '#B4C6FC',
    400: '#8DA2FB',
    500: '#6875F5',
    600: '#5850EC',
    700: '#5145CD',
    800: '#42389D',
    900: '#362F78'
  },
  purple: {
    50: '#F6F5FF',
    100: '#EDEBFE',
    200: '#DCD7FE',
    300: '#CABFFD',
    400: '#AC94FA',
    500: '#9061F9',
    600: '#7E3AF2',
    700: '#6C2BD9',
    800: '#5521B5',
    900: '#4A1D96'
  },
  pink: {
    50: '#FDF2F8',
    100: '#FCE8F3',
    200: '#FAD1E8',
    300: '#F8B4D9',
    400: '#F17EB8',
    500: '#E74694',
    600: '#D61F69',
    700: '#BF125D',
    800: '#99154B',
    900: '#751A3D'
  }
};

export const queryKeys = {
  GET_THERE_DIRECTION: 'get-there-direction-data',
  GET_DIRECTION: 'get-direction-data',
  GET_FEEDBACK_ERROR_TYPE: 'get-feedback-errortype',
  GET_LANGUAGE: 'get-language-data',
  GET_UNIVERSITY_COURSE_SELECT: 'get-university-course-select',
  GET_UNIVERSITY_COURSE_SELECT_BY_SLUG: 'get-university-course-select-by-slug',
  GET_YEAR_DATA: 'get-year-data',
  GET_HEART_DATA: 'get-heart-data',
  GET_HEART_XP_DATA: 'get-heart-ball-data',
  GET_ALL_REGION: 'get-all-region',
  SUBJECTS_DATA: 'subjects-data',
  SUBJECTS_NAME: 'subjects-name',
  USER_DATA: 'userData',
  FAQ: 'faq'
};

export const yandexGoalKeys = {
  wrong_answer: 'wrong_answer',
  footer_pro_banner: 'footer_pro_banner',
  header_pro_button: 'header_pro_button',
  profile_dropdown_pro: 'profile_dropdown_pro',
  auto_test_pro_banner: 'auto_test_pro_banner',
  mock_avto_test_pro_push: 'mock_avto_test_pro_push',
  check_test_pro: 'check_test_pro',
  dtm_pro: 'dtm_pro',
  limit_finished_pro: 'limit_finished_pro',
  course_lead: 'course_lead',
  rising_zone: 'rising_zone'
} as const;

export const pageNames = {
  CABINET: '/profile',
  CHECK_TEST: '/check',
  DTM: '/dtm',
  DTM_TEST: '/dtm/test',
  TOPIC_TEST: '/mavzuli-test',
  RESULTS: '/natijalar',
  OTM_LIST: '/otmlar-royhati',
  PRO: '/pro',
  PRO_PAYMENT: '/pro/payment',
  UNIVER_REC: '/univer-tavsiya',
  UNIVERSITIES: '/universitetlar',
  VIRTUAL: '/virtual',
  VIRTUAL_TEST: '/virtual/test',
  PRIVATE_UNIVERSITIES: '/xususiy-universitetlar',
  NEWS: '/yangiliklar',
  BLOCK_TEST: '/blok-test',
  LOGIN: '/login',
  SAVED_TEST: '/saqlangan-testlar',
  UNFINISHED: '/yakunlanmaganlar',
  NOT_FOUND: '/404',
  PRIVACY_POLICY: '/privacy',
  EXAM: '/exam',
  ONLINE_OLYMPIC: '/online-olimpiadalar',
  COURSES: '/kurslar',
  COURSES_FILTER: '/kurslar/filter',
  TEACHER: '/ustoz',
  AUTO_TEST: '/avtotest',
  AUTO_TEST_LEADERBOARD: '/avtotest/leaderboard',
  AUTO_TEST_PROCESS: '/avtotest/test',
  AUTO_TEST_RESULT: '/avtotest/result',
  NATIONAL_CERTIFICATE: '/milliy-sertifikat',
  NATIONAL_CERTIFICATE_TEST: '/milliy-sertifikat/test',
  NATIONAL_CERTIFICATE_RESULT: '/milliy-sertifikat/result',
  DTM_RESULT: '/dtm/result'
};

export const defaultLocation = {
  latitude: 41.2995,
  longitude: 69.2401

  // Tashkent
};

export const hiddenFooterRoutes = [
  pageNames.PRO,
  pageNames.DTM,
  pageNames.LOGIN,
  pageNames.VIRTUAL,
  pageNames.OTM_LIST,
  pageNames.DTM_TEST,
  pageNames.NOT_FOUND,
  pageNames.PRO_PAYMENT,
  pageNames.VIRTUAL_TEST,
  pageNames.AUTO_TEST_PROCESS,
  `${pageNames.EXAM}/[universitySlug]`,
  `${pageNames.ONLINE_OLYMPIC}/test/[id]`,
  `${pageNames.COURSES}/[course]/[lesson]`,
  `${pageNames.AUTO_TEST_PROCESS}/[testId]`,
  `${pageNames.TOPIC_TEST}/[subject]/[testId]`,
  `${pageNames.EXAM}/[universitySlug]/[directionSlug]`,
  `${pageNames.PRIVATE_UNIVERSITIES}/[universityId]/[directionName]/test`
];

export const hiddenHeaderRoutes = [
  pageNames.LOGIN,
  pageNames.DTM_TEST,
  pageNames.PRO_PAYMENT,
  pageNames.VIRTUAL_TEST,
  pageNames.AUTO_TEST_PROCESS,
  `${pageNames.EXAM}/[universitySlug]`,
  `${pageNames.ONLINE_OLYMPIC}/test/[id]`,
  `${pageNames.COURSES}/[course]/[lesson]`,
  `${pageNames.AUTO_TEST_PROCESS}/[testId]`,
  `${pageNames.TOPIC_TEST}/[subject]/[testId]`,
  `${pageNames.EXAM}/[universitySlug]/[directionSlug]`,
  `${pageNames.PRIVATE_UNIVERSITIES}/[universityId]/[directionName]/test`
];

export const policyPages = [
  pageNames.PRIVACY_POLICY,
  pageNames.LOGIN,
  pageNames.CABINET,
  pageNames.SAVED_TEST,
  pageNames.UNFINISHED
];

export const visibleMobileFooter = [
  pageNames.AUTO_TEST,
  pageNames.DTM,
  pageNames.COURSES,
  pageNames.TOPIC_TEST,
  pageNames.NATIONAL_CERTIFICATE,
  pageNames.RESULTS,
  pageNames.ONLINE_OLYMPIC,
  pageNames.PRO,
  pageNames.CABINET,
  pageNames.UNIVER_REC,
  pageNames.UNIVERSITIES,
  pageNames.VIRTUAL,
  pageNames.PRIVATE_UNIVERSITIES,
  pageNames.NEWS,
  pageNames.BLOCK_TEST,
  pageNames.SAVED_TEST,
  pageNames.UNFINISHED,
  `/`
];

export const extraTranslation = {
  header: {
    uz: {
      bosh_sahifa: 'Bosh sahifa',
      mavzuli_test: 'Mavzuli test',
      blok_test: 'Blok test',
      oliygohlar: 'Oliygohlar',
      yangiliklar: 'Yangiliklar',
      xususiy_universitetlar: 'Xususiy universitetlar',
      platforma_test_rejimida_ishlamoqda: 'Platforma sinov rejimida ishlamoqda!',
      kirish: 'Kirish',
      avvalgi_talqinga_qaytish: 'Avvalgi talqinga qaytish',
      yangi: 'yangi',
      courses: 'Kurslar',
      online_olympics: 'Onlayn olimpiadalar',
      avto_test: 'Avto test',
      royxatdan_otish: "Bepul ro'yxatdan o'tish",
      xatolar_va_takliflar: 'Xatolar va takliflar'
    },
    ru: {
      bosh_sahifa: 'Главная страница',
      mavzuli_test: 'Тематический тест',
      blok_test: 'Блок тест',
      oliygohlar: 'Университеты',
      yangiliklar: 'Новости',
      xususiy_universitetlar: 'Частные университеты',
      platforma_test_rejimida_ishlamoqda: 'Платформа работает в тестовом режиме!',
      kirish: 'Войти',
      avvalgi_talqinga_qaytish: 'Вернуться к предыдущей версии',
      yangi: 'новый',
      courses: 'Курсы',
      online_olympics: 'Онлайн олимпиады',
      avto_test: 'Авто тест',
      royxatdan_otish: 'Бесплатная регистрация',
      xatolar_va_takliflar: 'Ошибки и предложения'
    }
  },
  heart_modal: {
    uz: {
      yurak_tugadi: 'Yurak tugadi',
      keyin_yurak_toladi: "Keyin yurak to'ladi",
      sotib_olish: 'Sotib olish',
      keyinroq: 'Keyinroq'
    },
    ru: {
      yurak_tugadi: 'Сердца закончились',
      keyin_yurak_toladi: 'Позже сердце пополнится',
      sotib_olish: 'Купить',
      keyinroq: 'Позже'
    }
  },
  footer: {
    uz: {
      pro_banner: {
        title: 'Akam bilan talaba bo‘ling',
        day: 'kun',
        subscribe_pro: "Pro ga obuna bo'lish"
      },
      footer_title:
        'Bizning platforma — O‘zbekiston bo‘ylab abituriyentlar uchun yaratilgan zamonaviy va qulay test tizimi bo‘lib, turli fanlardan bilimlaringizni sinash, tayyorgarlik darajangizni baholash va imtihonlarga samarali tayyorlanishingizga yordam beradi.',
      contact_us: "Biz bilan bog'lanish",
      social: 'Ijtimoiy tarmoqlarimiz',
      contact: 'Tel',
      address: 'Manzil',
      location: "Toshkent shahri, Ahmad Donish ko'chasi, 20A 100180"
    },
    ru: {
      pro_banner: {
        title: 'Станьте студентом с Akam',
        day: 'день',
        subscribe_pro: 'Подписаться на Pro'
      },
      footer_title:
        'Наша платформа — это современная и удобная тестовая система, созданная для абитуриентов по всему Узбекистану. Она поможет вам проверить знания по различным предметам, оценить уровень подготовки и эффективно подготовиться к экзаменам.',
      contact_us: 'Свяжитесь с нами',
      social: 'Социальные сети',
      contact: 'Tel',
      address: 'Адрес',
      location: 'г. Ташкент, улица Ахмада Дониша, 20А, 100180'
    }
  },
  home: {
    uz: {
      title: '📚 Akam.uz – Onlayn Testlar, DTM Tayyorlov va Bilim Sinovlari! 🚀',
      description:
        '🎯 DTM, mavzuli va avto testlar – barchasi bir joyda! 🏆 Bilimingizni sinab ko‘ring, natijalaringizni baholang va yangi marralarni zabt eting! ✅'
    },
    ru: {
      title: '📚 Akam.uz – Онлайн Тесты, Подготовка к DTM и Проверка Знаний! 🚀',
      description:
        '🎯 DTM, тематические и авто тесты – всё в одном месте! 🏆 Проверьте свои знания, оцените результаты и достигайте новых высот! ✅'
    }
  },
  error_page: {
    uz: {
      kechirasiz_nimadur_xato_ketdi: 'Kechirasiz, tizimda xatolik yuz berdi!',
      last_step_button: 'Asosiy sahifaga',
      adminga_xabar_berish: 'Adminga xabar berish'
    },
    ru: {
      kechirasiz_nimadur_xato_ketdi: 'Извините, произошла ошибка в системе!',
      last_step_button: 'На главную страницу',
      adminga_xabar_berish: 'Сообщить администратору'
    }
  }
};
